import { Box, DialogActions, DialogContent, DialogTitle, FormControl, Icon, Switch, TextField, Typography } from "@mui/material";
import CustomDialog from 'components/custom/CustomDialog';
import { CustomButton } from "components/roundedbutton/CustomButton";
import { useSnackbarCustom } from "hooks/useSnackCustom";
import { useCallback, useState } from "react";
import { useAppSelector } from "redux/hooks";

import CustomToolTips from "components/CustomToolTips";
import HeaderOuBannerDependendoDaInterpretacaoH1 from "layout/header-ou-banner-dependendo-da-interpretacao-h1/HeaderOuBannerDependendoDaInterpretacaoH1";
import { theme } from "theme";
import { currencyOf } from "utils/util";
import { TipoDescontoAcrescimoAutorizador, TipoDescontoAcrescimoAutorizadorLabelDescritivo } from "./Configuracoes.model";

type TAutorizaDesconto = {
    onClose: () => void;
    valorSolicitado: React.MutableRefObject<number | null>;
    onAutorizaDesconto: (username: string, password: string, switchBoolean: boolean) => void;
    tipoDescontoAcrescimoAutorizador: TipoDescontoAcrescimoAutorizador;
};

const initialState = {
    username: "",
    password: "",
    switchBoolean: false,
    showSwitchInfo: false,
    showPassword: false
};

const AutorizaDescontoAcrescimo = (props: TAutorizaDesconto) => {
    const { descontoMaximoItem, descontoMaximoPedido, acrescimoMaximoPedido } = useAppSelector(e => e.configuracoes.configuracaoDesconto);
    const [stateLocal, setStateLocal] = useState(initialState);
    const { addError } = useSnackbarCustom();

    const onChangeUsername = useCallback((username: string) => {
        setStateLocal(prevState => ({ ...prevState, username }));
    }, []);

    const onChangePassword = useCallback((password: string) => {
        setStateLocal(prevState => ({ ...prevState, password }));
    }, []);

    const toggleSwitch = () => {
        setStateLocal(prevState => ({ ...prevState, switchBoolean: !stateLocal.switchBoolean }));
    };

    const togglePasswordVisibility = () => {
        setStateLocal(prevState => ({ ...prevState, showPassword: !stateLocal.showPassword }));
    };

    const handleAutorization = () => {
        if (!stateLocal.username && !stateLocal.password) {
            return addError({ id: 'autoriza-desconto-nousername-nopassword-error', message: 'Usuário e senha são obrigatórios', preventDuplicate: false, closeable: true, persist: false });
        }
        props.onAutorizaDesconto(stateLocal.username, stateLocal.password, stateLocal.switchBoolean);
    };

    return (
        <CustomDialog
            id="desconto-fixo-dialog"
            open={true}
            onClose={props.onClose}
            fullWidth
        >
            <DialogTitle>
                <HeaderOuBannerDependendoDaInterpretacaoH1
                    id={"autoriza-desconto"}
                    label={"Autorizar desconto e acréscimo"}
                    iconClassName="fa-solid fa-percent"
                    small
                />
            </DialogTitle>

            <DialogContent>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '6px'
                }}>
                    <Typography sx={{ fontSize: '18px', display: 'flex', justifyContent: 'space-between' }}>
                        <span>
                            Desconto máximo no item do usuário:
                        </span>
                        <span>
                            {descontoMaximoItem.toFixed(2)}%
                        </span>
                    </Typography>

                    <Typography sx={{ fontSize: '18px', display: 'flex', justifyContent: 'space-between' }}>
                        <span>
                            Desconto máximo no pedido do usuário:
                        </span>
                        <span>
                            {descontoMaximoPedido.toFixed(2)}%
                        </span>
                    </Typography>

                    <Typography sx={{ fontSize: '18px', display: 'flex', justifyContent: 'space-between' }}>
                        <span>
                            Acréscimo máximo no pedido do usuário:
                        </span>
                        <span>
                            {currencyOf(acrescimoMaximoPedido)}
                        </span>
                    </Typography>

                    <Typography sx={{ fontSize: '18px', display: 'flex', justifyContent: 'space-between', color: theme.palette.error.main }}>
                        <span>
                            {TipoDescontoAcrescimoAutorizadorLabelDescritivo[props.tipoDescontoAcrescimoAutorizador]}:
                        </span>
                        <span>
                            {props.tipoDescontoAcrescimoAutorizador === TipoDescontoAcrescimoAutorizador.ACRESCIMO_PEDIDO
                                ? currencyOf(props.valorSolicitado.current!)
                                : `${props.valorSolicitado.current!.toFixed(2)}%`
                            }
                        </span>
                    </Typography>
                </Box>

                <form autoComplete="off" style={{ marginTop: '10px', display: 'flex', gap: '6px' }}>
                    <FormControl fullWidth>
                        <TextField
                            label="Usuário"
                            fullWidth
                            inputProps={{ id: 'autoriza-desconto-item-usuario' }}
                            variant="standard"
                            value={stateLocal.username}
                            id="autoriza-desconto-item-usuario"
                            onChange={(e) => onChangeUsername(e.target.value)}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField
                            label="Senha"
                            fullWidth
                            inputProps={{
                                id: 'autoriza-desconto-item-senha',

                            }}
                            variant="standard"
                            value={stateLocal.password}
                            id="autoriza-desconto-item-senha"
                            onChange={(e) => onChangePassword(e.target.value)}
                            type={stateLocal.showPassword ? 'text' : 'password'}
                            InputProps={{
                                endAdornment: <Icon
                                    sx={{ cursor: 'pointer', fontSize: '14px', width: 'auto', marginRight: '5px' }}
                                    onClick={togglePasswordVisibility}
                                    className={stateLocal.showPassword ? "fa-regular fa-eye" : "fa-solid fa-eye-slash"}
                                />
                            }}

                        />
                    </FormControl>
                </form>
                {props.tipoDescontoAcrescimoAutorizador === TipoDescontoAcrescimoAutorizador.DESCONTO_ITEM &&
                    <Box sx={{ marginTop: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography sx={{ width: '80%', fontSize: '18px' }}>Autorizar para todos itens deste pedido?</Typography>
                        <Switch
                            id='autoriza-desconto-todos-itens-switch'
                            color='primary'
                            checked={stateLocal.switchBoolean}
                            onClick={toggleSwitch} />
                        <Icon
                            sx={{
                                fontSize: '16px'
                            }}
                            onMouseOver={() => setStateLocal(prevState => ({ ...prevState, showSwitchInfo: true }))}
                            onMouseLeave={() => setStateLocal(prevState => ({ ...prevState, showSwitchInfo: false }))}
                            className="fa-solid fa-info"
                        />
                        {stateLocal.showSwitchInfo &&
                            <CustomToolTips
                                id="autoriza-desconto-info-tooltip"
                                position='absolute'
                                bottom='130px'
                                left='20px'
                                bgColor={theme.palette.grey[500]}
                                color={theme.palette.background.default}
                                height='auto'
                                maxWidth={'575px'}
                                zIndex={100}
                                display='flex'
                                justifyContent='center'
                                alignItems='center'
                                borderRadius='10px'
                                isVisible={true}
                                trueText='Se ativado o usuário poderá utilizar o desconto máximo autorizado para os demais itens deste pedido.'
                                falseText=''
                                autoCapitalize={false}

                            />
                        }
                    </Box>
                }
            </DialogContent>

            <DialogActions
                sx={{
                    justifyContent: 'space-between'
                }}>
                <CustomButton
                    id="autoriza-desconto-cancelar-btn"
                    onClick={props.onClose}
                    variant="contained"
                    color="error">
                    Não autorizar
                </CustomButton>

                <CustomButton
                    id="autoriza-desconto-confirmar-btn"
                    onClick={handleAutorization}
                    type="submit"
                    variant="contained"
                    color="success">
                    Autorizar
                </CustomButton>
            </DialogActions>
        </CustomDialog >
    );
};

export default AutorizaDescontoAcrescimo;
